import { createSlice } from "@reduxjs/toolkit";

const chatSlice = createSlice({
  name: "chats",
  initialState: {
    chatmessages: [], // Directly storing the array of messages
    chatloading: false, // For loading state
  },
  reducers: {
    addMessage(state, action) {
      const { message } = action.payload;
      state.chatmessages.push(message); // Simply push message into the array
    },
    setChatMessages(state, action) {
      // Directly set the chat messages array
      state.chatmessages = action.payload;
    },
    setChatLoading(state, action) {
      const { isLoading } = action.payload;
      state.chatloading = isLoading; // Set the loading state
    },
  },
});

export const { addMessage, setChatMessages, setChatLoading } =
  chatSlice.actions;
export default chatSlice.reducer;
